import React from 'react';
import { getURLSearchParams } from '../../../../../ui-kitchen/src/utils/searchParamUtils';
import { getTranslation } from '../../../../../ui-kitchen/src/providers/TranslationProvider';
import IconGreenCheck from '../../../../../ui-kitchen/src/components/IconGreenCheck';

const ConfirmCancelControllerView = () => {
  const params = getURLSearchParams();
  const message = params.get('message');
  const venueId = params.get('venueId');
  const venueName = params.get('venueName');
  const header = getTranslation({ translationKey: 'cancel_confirmation_header', fallback: 'Cancelled' });
  const cta = getTranslation({
    fallback: `Book another table at ${venueName}?`,
    translationKey: 'book_another',
    translationValues: { venueName },
  });
  const link = `/#/venues/${venueId}`;

  return (
    <section className="page-content">
      <div id="main-content">
        <div aria-hidden="true"><IconGreenCheck /></div>
        <h1>{header}</h1>
        <div id="mssg">{message}</div>
        <div id="reBook">
          <a href={link}>{cta}</a>
        </div>
      </div>
    </section>
  );
};

export default ConfirmCancelControllerView;
